"use client";

import React from "react";
import { IconBox } from "./icon-box";

interface IconBoxGrid {
  features: {
    heading: string;
    description: string;
    image: any;
  }[];
}

export const IconBoxGrid = ({ features }: IconBoxGrid) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-6">
      {features.map((feature, index) => (
        <IconBox key={feature.heading} feature={feature} index={index} />
      ))}
    </div>
  );
};
